export const starterData = [
  {
    name: "Cornish - Mackerel",
    price: "$20.00",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/food/dish-1.jpg.webp",
    id: "dish1"
  },
  {
    name: "Roasted Steak",
    price: "$29.00",
    desc: "A small river named Duden flows by their place and supplies",
    id: "dish2",
    imgPath: "assets/images/food/dish-2.jpg.webp"
  },
  {
    name: "Seasonal Soup",
    price: "$20.00",
    id: "dish3",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/food/dish-3.jpg.webp"
  },
  {
    name: "Chicken Curry",
    price: "$20.00",
    id: "dish4",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/food/dish-4.jpg.webp"
  },
]
